import React from "react";

export default function InventoryTabs({ tabs, activeTab, onChange }) {
  return (
    <div className="mt-5 flex flex-wrap gap-3">
      {tabs.map((item) => {
        const Icon = item.icon;
        const active = activeTab === item.key;

        return (
          <button
            key={item.key}
            type="button"
            onClick={() => onChange(item.key)}
            className={[
              "inline-flex items-center gap-2 rounded-full border px-4 py-2 text-[13px] font-semibold transition",
              active
                ? "border-[#d86a78] bg-[#fff6f7] text-[#d86a78]"
                : "border-[#f2c6cc] bg-white text-slate-600 hover:bg-[#fff8f9]",
            ].join(" ")}
          >
            <Icon size={16} />
            {item.label}
          </button>
        );
      })}
    </div>
  );
}